import React from "react";
import Layout from "../layout/layout";
import "./Carriers.css";

import p1 from "../../images/carriers/1.png";
import p3 from "../../images/carriers/3.png";
import p4 from "../../images/carriers/4.png";
import p2 from "../../images/carriers/2.png";
import p5 from "../../images/carriers/5.png";
import p6 from "../../images/carriers/6.png";
import p7 from "../../images/carriers/7.png";
import p8 from "../../images/carriers/8.png";
import p9 from "../../images/carriers/9.png";
import p10 from "../../images/carriers/10.png";
import p11 from "../../images/carriers/11.png";
import p12 from "../../images/carriers/12.png";
import p13 from "../../images/carriers/13.png";
import p14 from "../../images/carriers/14.png";
import p15 from "../../images/carriers/15.png";
import p16 from "../../images/carriers/16.png";
import p17 from "../../images/carriers/17.png";
import p18 from "../../images/carriers/18.png";
import p19 from "../../images/carriers/19.png";
import p20 from "../../images/carriers/20.png";
import p21 from "../../images/carriers/21.png";
import p22 from "../../images/carriers/22.png";
import p23 from "../../images/carriers/23.png";
import p24 from "../../images/carriers/24.png";
import p25 from "../../images/carriers/25.png";
import p26 from "../../images/carriers/26.png";
import p27 from "../../images/carriers/27.png";
import p28 from "../../images/carriers/28.png";

function Carriers() {
  return (
    <Layout>
      <div className="carriersContent">
        <div className="carrierMiddle">
          <div className="carrierInfo">
            <div className="carrierInfoText">
              <h1>A Platform Built for Producers</h1>
              <p className="subhead">
                National carrier access. In-person training. Built to scale.
              </p>
              <hr />
              <div className="copy">
                <p>
                  Reszko Nation operates on a national platform built through
                  strategic partnerships with more than 30 A-rated carriers.
                  This gives our Associates the flexibility to design solutions
                  around clients — not around limitations.
                </p>
                <p>
                  Our carrier relationships extend beyond contracts. Executives
                  and representatives frequently train with our team in person,
                  providing direct insight into underwriting, product strategy,
                  and market positioning. This level of access ensures that our
                  professionals compete with knowledge, leverage, and
                  confidence.
                </p>
                <p>
                  In addition to standard carrier compensation, our platform
                  offers performance-based incentives and exclusive bonus
                  structures designed to reward production at scale. We believe
                  high-level performance should be supported by high-level
                  infrastructure.
                </p>
                <p>
                  When you build with Reszko Nation, you build on institutional
                  backing, national optionality, and a platform engineered for
                  long-term growth.
                </p>
              </div>
            </div>
          </div>
          <div className="carrierLogoWrapper">
            <div className="carrierLogoContainer">
              <img className="carrierLogo" src={p1} alt="" />
              <img className="carrierLogo" src={p2} alt="" />
              <img className="carrierLogo" src={p3} alt="" />
              <img className="carrierLogo" src={p4} alt="" />
              <img className="carrierLogo" src={p5} alt="" />
              <img className="carrierLogo" src={p6} alt="" />
              <img className="carrierLogo" src={p7} alt="" />
              <img className="carrierLogo" src={p8} alt="" />
              <img className="carrierLogo" src={p9} alt="" />
              <img className="carrierLogo" src={p10} alt="" />
              <img className="carrierLogo" src={p11} alt="" />
              <img className="carrierLogo" src={p12} alt="" />
              <img className="carrierLogo" src={p13} alt="" />
              <img className="carrierLogo" src={p14} alt="" />
              <img className="carrierLogo" src={p15} alt="" />
              <img className="carrierLogo" src={p16} alt="" />
              <img className="carrierLogo" src={p17} alt="" />
              <img className="carrierLogo" src={p18} alt="" />
              <img className="carrierLogo" src={p19} alt="" />
              <img className="carrierLogo" src={p20} alt="" />
              <img className="carrierLogo" src={p21} alt="" />
              <img className="carrierLogo" src={p22} alt="" />
              <img className="carrierLogo" src={p23} alt="" />
              <img className="carrierLogo" src={p24} alt="" />
              <img className="carrierLogo" src={p25} alt="" />
              <img className="carrierLogo" src={p26} alt="" />
              <img className="carrierLogo" src={p27} alt="" />
              <img className="carrierLogo" src={p28} alt="" />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Carriers;
